import { createRequestActionsSet } from "@store/shared/requestState"

export const login = createRequestActionsSet("auth", "LOGIN")
export const logout = createRequestActionsSet("auth", "LOGOUT")
export const signup = createRequestActionsSet("auth", "SIGNUP")
export const verify = createRequestActionsSet("auth", "VERIFY")
export const reAuth = createRequestActionsSet("auth", "REAUTHENTICATE")
export const updateCognitoIdentity = createRequestActionsSet("auth", "UPDATE_COGNITO_IDENTITY")
export const getCognitoIdentity = createRequestActionsSet("auth", "GET_COGNITO_IDENTITY")
